import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";

class Footer extends Component {
  render() {
    return (
      <div
        style={{
          backgroundColor: "black",
          padding: "20px",
          marginTop: "50px",
          paddingTop: "10px",
          paddingBottom: "30px"
        }}
      >
        <div>
          <div style={{ width: "50%", display: "inline-block" }}>
            <font color="white">
              <h6>{new Date().getFullYear()} - Lookaliker.com</h6>
            </font>
          </div>
          <div align="right" style={{ width: "50%", display: "inline-block" }}>
            <div style={{ display: "inline-block", margin: "10px" }}>
              <font color="white">
                <h5>
                  {<FontAwesome name="facebook-f" size="lg" color="white" />}
                </h5>
              </font>
            </div>
            <div style={{ display: "inline-block", margin: "10px" }}>
              <font color="white">
                <h5>
                  {<FontAwesome name="twitter" size="lg" color="white" />}
                </h5>
              </font>
            </div>
            <div style={{ display: "inline-block", margin: "10px" }}>
              <font color="white">
                <h5>
                  {<FontAwesome name="instagram" size="lg" color="white" />}
                </h5>
              </font>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js